import { ReportColumn } from './loadReport.ts'

interface ReportSortStateLike {
  key?: string
  order?: 'ascend' | 'descend'
}

export interface ReportSortCriterion {
  index: number
  order: 'ascend' | 'descend'
}

export const compareValues = (left: any, right: any) => {
  if (left == null && right == null) return 0
  if (left == null) return -1
  if (right == null) return 1
  if (typeof left === 'number' && typeof right === 'number') return left - right
  return String(left).localeCompare(String(right), undefined, { numeric: true, sensitivity: 'base' })
}

export const buildKeyColumnOrder = (columns: ReportColumn[], keyColumnKeys: string[]) => {
  const indexByColumnKey = new Map(columns.map((column, index) => [String(column.key).toLowerCase(), index] as const))
  return keyColumnKeys
    .filter((key, idx, list) => list.indexOf(key) === idx)
    .filter((key) => indexByColumnKey.has(String(key).toLowerCase()))
}

export const buildSortPlan = (
  columns: ReportColumn[],
  sort: ReportSortStateLike,
  keyColumnOrder: string[],
): ReportSortCriterion[] => {
  if (!sort.key || !sort.order) {
    return []
  }

  const indexByColumnKey = new Map(columns.map((column, index) => [String(column.key).toLowerCase(), index] as const))
  const sortedColumnIndex = indexByColumnKey.get(String(sort.key).toLowerCase()) ?? -1
  if (sortedColumnIndex === -1) {
    return []
  }

  const keyIndices = keyColumnOrder
    .map((columnKey) => indexByColumnKey.get(String(columnKey).toLowerCase()))
    .filter((index): index is number => index !== undefined)

  const sortedKeyIndex = keyIndices.indexOf(sortedColumnIndex)
  if (sortedKeyIndex >= 0) {
    return keyIndices.slice(sortedKeyIndex).map((index) => ({ index, order: sort.order! }))
  }

  return [{ index: sortedColumnIndex, order: sort.order }, ...keyIndices.map((index) => ({ index, order: 'ascend' as const }))]
}
